export enum ButtonHtmlType {
  Submit = 'submit',
  Button = 'button',
  Reset = 'reset',
}
